export default {"src":"/_next/static/media/lacrosse.33ebd8c7.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};